<template>
  <div id="editLibraryLinkWrapper">
    <div class="field">
      <label class="label">Bestand</label>

      <div class="control">
        <uploader
          uri="library/upload"
          label="Upload bestand"
          action="files/upload"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Uploader from '@/components/modules/Uploader'

export default {
  name: 'EditLibraryFile',

  components: {Uploader},

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters({
      file: 'files/file'
    })
  },

  watch: {
    file () {
      this.set('file', this.file)
    }
  },

  methods: {
    set(key, value) {
      this.$store.commit('library/SET', { key, value })
    }
  }
}
</script>

<style scoped>

</style>
